<template>
  <svg ref="barcode"></svg>
</template>

<script>
import JsBarcode from 'jsbarcode';

export default {
  name: 'barcode',
  props: {
    value: {
      type: Number | String
    }
  },
  mounted() {
    JsBarcode(this.$refs.barcode, this.value, {
      width: 1.2,
      height: 32,
      background: '#FAFAFA',
      fontSize: 10,
      margin: 0
    });
  }
};
</script>

<style scoped lang="less"></style>
